// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type VilDuViteMerListPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type VilDuViteMerListPageQuery = { paginateHelpPages?: { total?: unknown, items?: Array<{ id?: string, published: boolean, title?: string, order: number, locations?: Array<Types.HelpPageLocation>, createdAt?: string, image?: { url?: string, reference?: string, provider?: string }, content?: { json?: string, html?: string } }> } };

export type VilDuViteMerDetailsFragment = { id?: string, published: boolean, title?: string, order: number, locations?: Array<Types.HelpPageLocation>, createdAt?: string, image?: { url?: string, reference?: string, provider?: string }, content?: { json?: string, html?: string } };

export type GetVilDuViteMerQueryVariables = Types.Exact<{
  helpPageId: Types.Scalars['String']['input'];
}>;


export type GetVilDuViteMerQuery = { singleHelpPage?: { id?: string, published: boolean, title?: string, order: number, locations?: Array<Types.HelpPageLocation>, createdAt?: string, image?: { url?: string, reference?: string, provider?: string }, content?: { json?: string, html?: string } } };

export type UpsertVilDuViteMerMutationVariables = Types.Exact<{
  helpPage: Types.HelpPageInput;
}>;


export type UpsertVilDuViteMerMutation = { upsertHelpPage?: { id?: string, published: boolean, title?: string, order: number, locations?: Array<Types.HelpPageLocation>, createdAt?: string, image?: { url?: string, reference?: string, provider?: string }, content?: { json?: string, html?: string } } };

export type DeleteVilDuViteMerMutationVariables = Types.Exact<{
  helpPageId: Types.Scalars['String']['input'];
}>;


export type DeleteVilDuViteMerMutation = { deleteHelpPage?: { id?: string, published: boolean, title?: string, order: number, locations?: Array<Types.HelpPageLocation>, createdAt?: string, image?: { url?: string, reference?: string, provider?: string }, content?: { json?: string, html?: string } } };

export const VilDuViteMerDetailsFragmentDoc = gql`
    fragment VilDuViteMerDetails on HelpPage {
  id
  published
  title
  order
  locations
  image {
    url
    reference
    provider
  }
  content {
    json
    html
  }
  createdAt
}
    `;
export const VilDuViteMerListPageDocument = gql`
    query VilDuViteMerListPage {
  paginateHelpPages {
    total
    items {
      ...VilDuViteMerDetails
    }
  }
}
    ${VilDuViteMerDetailsFragmentDoc}`;

/**
 * __useVilDuViteMerListPageQuery__
 *
 * To run a query within a React component, call `useVilDuViteMerListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVilDuViteMerListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVilDuViteMerListPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useVilDuViteMerListPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>(VilDuViteMerListPageDocument, options);
      }
export function useVilDuViteMerListPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>(VilDuViteMerListPageDocument, options);
        }
// @ts-ignore
export function useVilDuViteMerListPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>;
export function useVilDuViteMerListPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VilDuViteMerListPageQuery | undefined, VilDuViteMerListPageQueryVariables>;
export function useVilDuViteMerListPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>(VilDuViteMerListPageDocument, options);
        }
export type VilDuViteMerListPageQueryHookResult = ReturnType<typeof useVilDuViteMerListPageQuery>;
export type VilDuViteMerListPageLazyQueryHookResult = ReturnType<typeof useVilDuViteMerListPageLazyQuery>;
export type VilDuViteMerListPageSuspenseQueryHookResult = ReturnType<typeof useVilDuViteMerListPageSuspenseQuery>;
export type VilDuViteMerListPageQueryResult = ApolloReactCommon.QueryResult<VilDuViteMerListPageQuery, VilDuViteMerListPageQueryVariables>;
export const GetVilDuViteMerDocument = gql`
    query getVilDuViteMer($helpPageId: String!) {
  singleHelpPage(helpPageId: $helpPageId) {
    ...VilDuViteMerDetails
  }
}
    ${VilDuViteMerDetailsFragmentDoc}`;

/**
 * __useGetVilDuViteMerQuery__
 *
 * To run a query within a React component, call `useGetVilDuViteMerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVilDuViteMerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVilDuViteMerQuery({
 *   variables: {
 *      helpPageId: // value for 'helpPageId'
 *   },
 * });
 */
export function useGetVilDuViteMerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables> & ({ variables: GetVilDuViteMerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>(GetVilDuViteMerDocument, options);
      }
export function useGetVilDuViteMerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>(GetVilDuViteMerDocument, options);
        }
// @ts-ignore
export function useGetVilDuViteMerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>;
export function useGetVilDuViteMerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVilDuViteMerQuery | undefined, GetVilDuViteMerQueryVariables>;
export function useGetVilDuViteMerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>(GetVilDuViteMerDocument, options);
        }
export type GetVilDuViteMerQueryHookResult = ReturnType<typeof useGetVilDuViteMerQuery>;
export type GetVilDuViteMerLazyQueryHookResult = ReturnType<typeof useGetVilDuViteMerLazyQuery>;
export type GetVilDuViteMerSuspenseQueryHookResult = ReturnType<typeof useGetVilDuViteMerSuspenseQuery>;
export type GetVilDuViteMerQueryResult = ApolloReactCommon.QueryResult<GetVilDuViteMerQuery, GetVilDuViteMerQueryVariables>;
export const UpsertVilDuViteMerDocument = gql`
    mutation UpsertVilDuViteMer($helpPage: HelpPageInput!) {
  upsertHelpPage(helpPage: $helpPage) {
    ...VilDuViteMerDetails
  }
}
    ${VilDuViteMerDetailsFragmentDoc}`;
export type UpsertVilDuViteMerMutationFn = ApolloReactCommon.MutationFunction<UpsertVilDuViteMerMutation, UpsertVilDuViteMerMutationVariables>;

/**
 * __useUpsertVilDuViteMerMutation__
 *
 * To run a mutation, you first call `useUpsertVilDuViteMerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVilDuViteMerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVilDuViteMerMutation, { data, loading, error }] = useUpsertVilDuViteMerMutation({
 *   variables: {
 *      helpPage: // value for 'helpPage'
 *   },
 * });
 */
export function useUpsertVilDuViteMerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertVilDuViteMerMutation, UpsertVilDuViteMerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertVilDuViteMerMutation, UpsertVilDuViteMerMutationVariables>(UpsertVilDuViteMerDocument, options);
      }
export type UpsertVilDuViteMerMutationHookResult = ReturnType<typeof useUpsertVilDuViteMerMutation>;
export type UpsertVilDuViteMerMutationResult = ApolloReactCommon.MutationResult<UpsertVilDuViteMerMutation>;
export type UpsertVilDuViteMerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertVilDuViteMerMutation, UpsertVilDuViteMerMutationVariables>;
export const DeleteVilDuViteMerDocument = gql`
    mutation DeleteVilDuViteMer($helpPageId: String!) {
  deleteHelpPage(helpPageId: $helpPageId) {
    ...VilDuViteMerDetails
  }
}
    ${VilDuViteMerDetailsFragmentDoc}`;
export type DeleteVilDuViteMerMutationFn = ApolloReactCommon.MutationFunction<DeleteVilDuViteMerMutation, DeleteVilDuViteMerMutationVariables>;

/**
 * __useDeleteVilDuViteMerMutation__
 *
 * To run a mutation, you first call `useDeleteVilDuViteMerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVilDuViteMerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVilDuViteMerMutation, { data, loading, error }] = useDeleteVilDuViteMerMutation({
 *   variables: {
 *      helpPageId: // value for 'helpPageId'
 *   },
 * });
 */
export function useDeleteVilDuViteMerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteVilDuViteMerMutation, DeleteVilDuViteMerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteVilDuViteMerMutation, DeleteVilDuViteMerMutationVariables>(DeleteVilDuViteMerDocument, options);
      }
export type DeleteVilDuViteMerMutationHookResult = ReturnType<typeof useDeleteVilDuViteMerMutation>;
export type DeleteVilDuViteMerMutationResult = ApolloReactCommon.MutationResult<DeleteVilDuViteMerMutation>;
export type DeleteVilDuViteMerMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteVilDuViteMerMutation, DeleteVilDuViteMerMutationVariables>;